import { useState } from 'react';
import { Menu, MenuItem, IconButton, Divider, Box } from '@mui/material';
import { FaEllipsisH } from 'react-icons/fa';

const ActionMenu = ({ options }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <Box>
      <IconButton onClick={handleClick}>
        <FaEllipsisH fontSize={22}/>
      </IconButton>
      <Menu 
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
            style: {
              border: '1px solid #ccc',
              borderRadius: '4px',
            },
          }}
        sx={{
            '& .MuiList-root': {
                py: '0px',
            },
        }}
    >
        {options.map((option, index, arr) => (
        <Box key={index} p={0}>
            <MenuItem
              onClick={() => {
                option.action();
                handleClose();
              }}
              sx={{
                  color: 'primary.main',
                  fontWeight: 500,
                  justifyContent: 'center',
                }}
            >
              {option.label}
            </MenuItem>
          {index < arr.length - 1 && <Divider sx={{ borderColor: 'primary', my: '0px !important' }}/>}
        </Box>

        ))}
      </Menu>
    </Box>
  );
};

export default ActionMenu;
